




import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import { AdminRoles, AdminRoleList } from '@/configs/role';
import { UserInfo } from '@/models/user';
import AppModule from '@/store/modules/app';

@Component
export default class PageHome extends Vue {
  created() {
    const user = this.$store.getters['user/currentUser'] as UserInfo;

    if (!user) {
      const appModule = getModule(AppModule, this.$store);
      appModule.setSessionMessage({
        type: 'danger',
        message: '請先登入。',
      });
      this.$router.replace({
        name: 'auth-login',
      });
      return;
    }

    if ((user.role as AdminRoleList).code === AdminRoles.staff) {
      const { projectId } = user;

      if (projectId) {
        this.$router.replace({
          name: 'resident-list',
          params: {
            projectId: projectId.toString(),
          },
        });
        return;
      }
    }

    this.$router.replace({
      name: 'admin-list',
    });
  }
}
